import React from 'react'
import Icon from '~/Common-Objects/UI/Icon'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import './style.scss'

const Wrapper = ({ children, onClose, ...rest }) => {
    return (
        <Paper className='callout' {...rest}>
            {children}
            {onClose && (
                <button className='callout__close-btn' onClick={onClose} data-ph='dismiss-callout'>
                    <Icon name='cross' />
                </button>
            )}
        </Paper>
    )
}

const Splash = ({ children, ...rest }) => {
    return (
        <div className='callout__splash' {...rest}>
            {children}
        </div>
    )
}

const Content = ({ children, ...rest }) => {
    return (
        <div className='callout__content' {...rest}>
            {children}
        </div>
    )
}

export default {
    Wrapper,
    Splash,
    Content
}
